<template>
    <a-row
        v-for="notification in notifications"
        :key="notification.id"
        class="notification-item"
        :class="{'unread-item': isUnreadItem(notification)}"
        v-on:mouseenter="markItemAsRead(notification)"
    >
        <a-row class="notification-item-header">
            <a-col :xs="12">
                <img class="social-icon" :src="$socialMediaService.getIconById(notification.socialType)" />
                <span class="social-name">{{ notification.entityName }}</span>
            </a-col>
            <a-col :xs="12" class="dismiss-block">
                <a-button type="link" @click="dismiss(notification)" v-if="showDismissButton">
                    <span>Dismiss</span>
                </a-button>
            </a-col>
        </a-row>
        <a-row class="notification-text">
            <notification-text :notification="notification"></notification-text>
        </a-row>
        <a-row class="notification-bottom-row">
            <a-col :xs="12" class="notification-action">
                <a :href="profilesUrl" v-if="isShowProfileLink(notification)">
                    <span>Go to Profiles</span>
                </a>
            </a-col>
            <a-col :xs="12" class="notification-date">
                {{ createAt(notification) }}
            </a-col>
        </a-row>
    </a-row>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import { url } from '@/config';
import NotificationText from './Text.vue';

export default {
    components: {
        NotificationText
    },

    props: {
        notifications: {
            default: () => [],
            type: Array,
            required: true
        },
        showDismissButton: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            markingIds: []
        };
    },

    computed: {
        profilesUrl() {
            return `${url}/settings/profiles`;
        }
    },

    methods: {
        ...mapActions({
            markAsRead: 'notifications/markAsRead',
            update: 'notifications/update'
        }),

        async markItemAsRead(notification) {
            if (!notification.readAt && !this.markingIds.some(id => id === notification.id)) {
                this.markingIds.push(notification.id);
                await this.markAsRead({ids: [notification.id]});
                this.markingIds = this.markingIds.filter(id => id !== notification.id);
            }
        },

        createAt(notification) {
            return moment(notification.createdAt).fromNow(true);
        },

        isUnreadItem(notification) {
            return !notification.readAt;
        },

        isShowProfileLink(notification) {
            return notification.category === 'permissions_error';
        },

        async dismiss(notification) {
            try {
                notification.dismissed = true;
                await this.update({id: notification.id, dismissed: true});
            } catch (error) {
                console.error(error);

                this.$toasterError('We were not able to mark notification as dismissed.');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.unread-item {
    background-color: #F5F8FA;
}

.notification-item {
    padding: 12px;
    width: 100%;

    .notification-item-header {
        display: flex;
        width: 100%;

        .social-icon {
            height: 16px;
            width: 16px;
            vertical-align: middle;
        }

        .social-name {
            color: #73818C;
            margin-left: 4px;
            vertical-align: middle;
        }

        .dismiss-block {
            text-align: right;

            .ant-btn-link {
                padding: 0;
                height: auto;
                color: #73818C;
            }
        }
    }

    .notification-text {
        color: #484848;
        display: block;
        width: 100%;
    }

    .notification-bottom-row {
        width: 100%;

        .notification-action {
            text-align: left;
        }

        .notification-date {
            text-align: right;
            color: #73818C;
        }
    }
}

.notification-item:hover {
    background-color: #F5F8FA;
}
</style>
